import { render, staticRenderFns } from "./local-presence-cancelation.vue?vue&type=template&id=8fda59a2"
import script from "./local-presence-cancelation.vue?vue&type=script&lang=js"
export * from "./local-presence-cancelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports